"use client";

/**
 * Scene0DynamicLayer — client overlay for Scene 0 above-fold.
 *
 * Mounted as the `children` of <Scene0Static>. Renders the AmbientBackground
 * (gradient + noise + vignette) as the decorative back layer behind the
 * server-rendered text content.
 *
 * Why a separate client component (vs. AmbientBackground inline in Scene0Static):
 * AmbientBackground uses framer-motion (`useReducedMotion`, `motion.div`) and
 * therefore must be a client component. Importing it directly from Scene0Static
 * would still work (RSC can import client components), but wrapping it in a
 * dedicated DynamicLayer makes the architectural split explicit and leaves
 * room for additional client-only overlays later without re-touching the RSC.
 *
 * The FoilMark and CyclingWord islands stay inline in Scene0Static (in their
 * natural flexbox layout positions). Their SSR markup reserves the correct
 * height → zero CLS on hydration. No absolute positioning needed.
 */

import { AmbientBackground } from "../shared/AmbientBackground";

export function Scene0DynamicLayer() {
  return <AmbientBackground origin="top-right" />;
}
